<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col md="3" cols="12">
                      <v-autocomplete
                        label="Status type"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="asset_status_id.value.value"
                        :items="getAssetStatusTypesList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="asset_status_id.errorMessage.value"
                        autocomplete="off"
                        :loading="locationLoading"
                        clearable
                      ></v-autocomplete>
                      <v-row class="pa-3">
                        <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                        >
                      </v-row>
                    </v-col>

                    <v-col md="3" cols="12">
                      <v-autocomplete
                        label="Category"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="asset_category_id.value.value"
                        :items="getAssetCategoryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="asset_category_id.errorMessage.value"
                        autocomplete="off"
                        :loading="statusTypeLoading"
                        clearable
                      ></v-autocomplete>

                    </v-col>
                    
                    <v-col md="3" cols="12">
                      <v-autocomplete
                      label="Location"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="asset_location_id.value.value"
                      :items="getAssetLocationsList"
                      :item-title="(item) => `${item.name}`"
                      item-value="id"
                      :error-messages="asset_location_id.errorMessage.value"
                      autocomplete="off"
                      :loading="depreciationMethodLoading"
                      clearable
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="3" cols="12">
                      <v-autocomplete
                      label="Depreciation Method"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="asset_depreciation_method_id.value.value"
                      :items="getAssetDepreciationMethodList"
                      :item-title="(item) => `${item.name}`"
                      item-value="id"
                      :error-messages="asset_depreciation_method_id.errorMessage.value"
                      autocomplete="off"
                      :loading="categoryLoading"
                      clearable
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Asset Registration Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2 justify-items-between">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/asset/asset-registration')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add New Asset
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.asset_status.name="{ item }">
                    <v-chip
                      color="blue"
                      size="small"
                      class="text-capitalize"
                      >{{ item.asset_status.name }}</v-chip
                    >
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                    v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                    color="yellow-darken-3"
                    size="small"
                    >
                        Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                    color="green"
                    size="small"
                    >
                        Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    
                    <v-chip
                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                    color="red"
                    size="small"
                    >
                        Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                    v-else
                    color="green"
                    size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                    v-if="item.status == 1"
                    color="success"
                    size="small"
                    class="text-capitalize"
                    >Active</v-chip>

                    <v-chip
                    v-else
                    color="red"
                    size="small"
                    class="text-capitalize"
                    >Inactive</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="orange"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath) && canEdit(item)"
                    />
                    
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="brown"
                      @click="viewAssetRecordDetails(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

  <input
    ref="csvInput"
    type="file"
    style="display: none"
    @change="handleCSVFile"
  />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {},
  data: () => ({
    itemsPerPage: "-1",
    panel: [0],
    search: "",
    dialog: false,
    data: {},

    statusTypeLoading: false,
    categoryLoading: false,
    locationLoading: false,
    depreciationMethodLoading: false,
    headers: [
      { title: "#SL", align: "center", key: "id", width: "100px", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: false, width: "100px" },
      { title: "Name", key: "name", align: "left", sortable: false },
      { title: "Book Value Start", key: "book_value_start", align: "left", sortable: false },
      { title: "Salvage Value", key: "salvage_value", align: "left", sortable: false },
      { title: "Category", key: "asset_category.name", align: "left", sortable: false },
      { title: "Asset Location", key: "asset_location.name", align: "left", sortable: false },
      { title: "Asset Status", key: "asset_status.name", align: "left", sortable: false },
      { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
      { title: "Status", key: "status", align: "left", sortable: false },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if(this.$store.getters.getAssetDepreciationMethodList.length == 0){
      this.depreciationMethodLoading = true;
      this.$store.dispatch('getAssetDepreciationMethodList').then((response) => {
          this.depreciationMethodLoading = false;
      })
    };
    if(this.$store.getters.getAssetCategoryList.length == 0){
      this.categoryLoading = true;
      this.$store.dispatch('getAssetCategoryList').then((response) => {
          this.categoryLoading = false;
      })
    };
    if(this.$store.getters.getAssetLocationsList.length == 0){
      this.locationLoading = true;
      this.$store.dispatch('getAssetLocationsList').then((response) => {
          this.locationLoading = false;
      })
    };
    if(this.$store.getters.getAssetStatusTypesList.length == 0){
      this.statusTypeLoading = true;
      this.$store.dispatch('getAssetStatusTypesList').then((response) => {
          this.statusTypeLoading = false;
      })
    };

  },
  computed: {
    getSchema() {
      return this.$store.getters.getAssetRegistrationsList;
    },

    getAssetDepreciationMethodList(){
      let data = this.$store.getters.getAssetDepreciationMethodList;
      if(data.length > 0){
          return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getAssetCategoryList(){
      let data = this.$store.getters.getAssetCategoryList;
      if(data.length > 0){
          return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getAssetLocationsList(){
      let data = this.$store.getters.getAssetLocationsList;
      if(data.length > 0){
          return data.filter((item) => item.status == 1);
      }
      return [];
    },
    getAssetStatusTypesList(){
      let data = this.$store.getters.getAssetStatusTypesList;
      if(data.length > 0){
          return data.filter((item) => item.status == 1);
      }
      return [];
    },

  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        //
      }),
    });

    const asset_location_id = useField("asset_location_id");
    const asset_category_id = useField("asset_category_id");
    const asset_status_id = useField("asset_status_id");
    const asset_depreciation_method_id = useField("asset_depreciation_method_id");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      loading.value = true;
      store
        .dispatch("getAssetRegistrationsList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      asset_location_id,
      asset_category_id,
      asset_status_id,
      asset_depreciation_method_id,
      submit,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    viewAssetRecordDetails(item) {
      this.$store.commit("SET_VIEW_ASSET_REGISTRATION",item);
      this.$router.push({
        name: "asset-record-details",
        params: { id: item.id },
      });
    },
    editItem(item) {
      this.$store.commit("SET_EDITING_ASSET_REGISTRATION", item);
      this.$router.push({ name: "asset-registration" });
    },
    canEdit(item){
      return (!item.approval_status || item.approval_status.toLowerCase() !== 'approved' || item.status == 0)
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Asset Registration List", "asset_registration_list_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [[ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "asset_registration_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[ "#SL","Code", "Name", "Book Value Start", "Salvage Value", "Asset Category", "Asset Location", "Status" ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.book_value_start, item.salvage_value, item.asset_category.name, item.asset_location.name, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "asset_registration_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.$refs.searchButton.$el.click();
  },  
};
</script>
